import {Component, Input, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {Breadcrumb} from 'primeng/breadcrumb';
import {Message} from 'primeng/message';
import {NavigationResolver} from '../../core/resolvers/navigation.resolver';
import {BannerIconResolver} from '../../core/resolvers/banner-icon.resolver';
import {Divider} from 'primeng/divider';
import {BannerSpec} from '../../core/models/banner-spec.model';

@Component({
  selector: 'app-panel',
  imports: [
    Breadcrumb,
    Message,
    Divider,
  ],
  templateUrl: './panel.component.html',
  styleUrl: './panel.component.css'
})
export class PanelComponent implements OnInit {
  @Input() public breadcrumb: boolean = true;
  @Input() public title: string | undefined = undefined;
  @Input() public banner: BannerSpec | undefined = undefined;

  protected items: MenuItem[] | undefined;
  protected home: MenuItem | undefined;

  constructor(
    private readonly bannerIconResolver: BannerIconResolver,
    private readonly navigationResolver: NavigationResolver) {
  }

  public ngOnInit(): void {
    this.resolveBreadcrumb();
  }

  protected resolveIcon(): string {
    return this.bannerIconResolver.resolve(this.banner?.type);
  }

  private resolveBreadcrumb(): void {
    const resolvedNavigation = this.navigationResolver.buildBreadcrumbs();
    this.home = resolvedNavigation[0];
    this.items = resolvedNavigation.slice(1);
  }
}
